/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { Suspense, FC, useEffect, useState } from 'react';
import { ConfigProvider } from 'ssc-ui-react';
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore
import styles from './index.module.less';
import I18nProvider from '@/react-app/utils/i18n/provider';
import { ProConfigProvider } from 'react-pro-components';
import { getEnv } from '@/utils/getEnv';
import { EventBus, getCurrentLocale } from '@/i18n';
import bnBD from '@/i18n/locales/bn_BD.json';
import neNP from '@/i18n/locales/ne_NP.json';
import axios from 'axios';

const isLive = getEnv() === 'live';
const customSSCReactLocales = {
  bn: bnBD,
  ne: neNP,
};

function getSSCReactLocale(locale: string | null) {
  const language = locale?.replace('_', '-').split('-')[0].toLowerCase();
  return language ? customSSCReactLocales[language] : undefined;
}
const storeServiceUrl = '/api/v2/apps/system/store_service/save_info/';
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

const Wrapper: FC = ({ children }) => {
  const [sscReactLocale, setSSCReactLocale] = useState(() =>
    getSSCReactLocale(getCurrentLocale())
  );

  useEffect(() => {
    const handleLanguageChange = () => {
      setSSCReactLocale(getSSCReactLocale(getCurrentLocale()));
    };

    EventBus.$on('langChange', handleLanguageChange);
    return () => {
      EventBus.$off('langChange', handleLanguageChange);
    };
  }, []);

  return (
    /* eslint-disable @typescript-eslint/ban-ts-comment */
    // @ts-ignore
    <Suspense fallback={''}>
      <I18nProvider>
        <ConfigProvider
          locale={sscReactLocale}
          prefixCls="ssc-react"
          rcPrefixCls="ssc-react-rc"
        >
          <ProConfigProvider
            storeService={{
              emailKey: 'wms_display_name',
              baseBt: 'SBS',
              isLive,
              baseSbt: 'WMSV2',
              storeServiceUrl,
            }}
          >
            <div className={styles.root} id="react-wrapper">
              {children}
            </div>
          </ProConfigProvider>
        </ConfigProvider>
      </I18nProvider>
    </Suspense>
  );
};

export default Wrapper;
